import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Button } from '../Button';
import { Icon } from '../../Icon';
import { BodyText } from '../../Text';
import { theme } from '@garnish/constants';

export const ButtonBag = (props: ButtonBagProps) => {
  const { bagCount, children, ...buttonProps } = props;

  if (!bagCount) return null;

  return (
    <Button
      palette="lime"
      rightElement={(state) => <BagIcon {...props} {...state} />}
      style={[styles.button, buttonProps.style]}
      {...buttonProps}
    >
      {children}
    </Button>
  );
};

export const BagIcon = ({ bagCount }: ButtonBagProps) => {
  return (
    <View style={styles.container}>
      <Icon
        width={24}
        height={24}
        name="IconBagFill"
        color={theme.colors.GREEN_1}
      />
      <BodyText size={5} style={styles.label}>
        {bagCount > 9 ? '9+' : bagCount}
      </BodyText>
    </View>
  );
};

type ButtonBagProps = {
  readonly bagCount: number;
} & React.ComponentProps<typeof Button>;

const styles = StyleSheet.create({
  button: {
    ...theme.elevations['12'],
  },
  container: {
    position: 'relative',
    marginLeft: theme.spacing.small,
    marginTop: -2,
  },
  label: {
    ...StyleSheet.absoluteFillObject,
    textAlign: 'center',
    lineHeight: 30,
    zIndex: 1,
    color: theme.colors.LIME,
  },
});
